import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  Navigate,
} from "react-router-dom";
import ScrollToTop from "./layout/ScrollToTop";
import HomeScreen from "./pages/userpanel/home";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import SearchScreen from "./pages/userpanel/search";
import PropertyDetailScreen from "./pages/userpanel/propertydetail";
import UserLogin from "./pages/userpanel/userauth/UserLogin";
import UserSignUp from "./pages/userpanel/userauth/UserSignUp";
import UserForgotPassword from "./pages/userpanel/userauth/UserForgotPassword";
import UserOTP from "./pages/userpanel/userauth/UserOTP";
import UserResetPassword from "./pages/userpanel/userauth/UserResetPassword";
import WishlistScreen from "./pages/userpanel/wishlist";
import AffiliateScreen from "./pages/userpanel/affiliate";
import UserProfileSettings from "./pages/userpanel/userprofilesettings";
import PropertyOwnerLogin from "./pages/propertyowner/propertyownerauth/PropertyOwnerLogin";
import PropertyOwnerSignUp from "./pages/propertyowner/propertyownerauth/PropertyOwnerSignUp";
import PropertyOwnerForgotPassword from "./pages/propertyowner/propertyownerauth/PropertyOwnerForgotPassword";
import PropertyOwnerOTP from "./pages/propertyowner/propertyownerauth/PropertyOwnerOTP";
import PropertyOwnerResetPassword from "./pages/propertyowner/propertyownerauth/PropertyOwnerResetPassword";
import AddpropertyScreen from "./pages/propertyowner/addproperty";
import PropertydashboardScreen from "./pages/propertyowner/propertydashboard";
import MyProperties from "./pages/propertyowner/myproperties/MyProperties";
import DiscountScreen from "./pages/propertyowner/discount";
import PropertyReviews from "./pages/propertyowner/propertyreviews";
import MyBookings from "./pages/propertyowner/mybookings";
import UserSignUpOTP from "./pages/userpanel/userauth/UserSignUpOTP";
import PropertySignUpOTP from "./pages/propertyowner/propertyownerauth/PropertySignUpOTP";
import PrivateRoute from "./routes/PrivateRoutes";
import PublicRoute from "./routes/PublicRoutes";
import HostRoute from "./routes/HostRoutes";
import UserRoute from "./routes/UserRoutes";
import PropertyBookings from "./pages/propertyowner/mybookings/propertyBookings";
import InfluencerRoutes from "./routes/influencerRotes";
import { FilterProvider } from "./utility/globle/providers/store/filterContext";
import NotFound from "./components/customcomponents/NotFound";
import ReviewListing from "./pages/ReviewList";
import "./i18n";
import { useTranslation } from "react-i18next";
import GmapsKeyTester from './components/maps/testgmaps';



function ScrollToTopMain() {
  const { pathname } = useLocation();

  useEffect(() => {
    // console.log('Go to top Working.')
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}




const ProtectedPropertyDetail = () => {
  const location = useLocation();
  return location?.state?.data ? <PropertyDetailScreen /> : <Navigate to="/" replace />;
};





function App() {
  const { t, i18n, ready } = useTranslation();

  useEffect(() => {
    if (ready) {
      console.log("i18n resources:", i18n.options.resources);
      document.documentElement.dir = i18n.language === "he" ? "rtl" : "ltr";
    }
  }, [i18n.language, ready]);

  return (
    <FilterProvider>
      <Router>
        <ScrollToTopMain />
        <Header />
        <div className="main-content-body">
          <Routes>
            <Route
              path="/"
              element={
                <HomeScreen />
              }
            />
            <Route
              path="/login"
              element={<PublicRoute element={UserLogin} restricted={true} />}
            />
            <Route
              path="/user-signup"
              element={<PublicRoute element={UserSignUp} />}
            />
            <Route
              path="/user-forgotpassword"
              element={<PublicRoute element={UserForgotPassword} />}
            />
            <Route
              path="/user-resetpassword"
              element={<PublicRoute element={UserResetPassword} />}
            />
            <Route
              path="/user-verify"
              element={<PublicRoute element={UserSignUpOTP} />}
            />
            <Route
              path="/wishlist"
              element={<UserRoute element={WishlistScreen} />}
            />
            <Route
              path="/my-referral"
              element={<InfluencerRoutes element={AffiliateScreen} />}
            />
            <Route path="/user-otp" element={<PublicRoute element={UserOTP} />} />
            <Route
              path="/search"
              element={<PublicRoute element={SearchScreen} />}
            />
            <Route
              path="/property-detail"
              element={<ProtectedPropertyDetail />}
            />
            <Route
              path="/user-profilesetting"
              element={<PrivateRoute element={UserProfileSettings} />}
            />

            <Route
              path="/propertyowner-login"
              element={<PublicRoute element={UserLogin} />}
            />
            <Route
              path="/propertyowner-signup"
              element={<PublicRoute element={PropertyOwnerSignUp} />}
            />
            <Route
              path="/forgotpassword"
              element={<PublicRoute element={PropertyOwnerForgotPassword} />}
            />
            <Route
              path="/verify-otp"
              element={<PublicRoute element={PropertyOwnerOTP} />}
            />
            <Route
              path="/resetpassword"
              element={<PublicRoute element={PropertyOwnerResetPassword} />}
            />
            <Route
              path="/addpropertyscreen"
              element={<HostRoute element={AddpropertyScreen} />}
            />
            <Route
              path="/property-dashboard"
              element={<PrivateRoute element={PropertydashboardScreen} />}
            />
            <Route
              path="/my-properties"
              element={<HostRoute element={MyProperties} />}
            />
            <Route
              path="/discount"
              element={<HostRoute element={DiscountScreen} />}
            />

            <Route
              path="/property-bookings"
              element={<HostRoute element={PropertyBookings} />}
            />

            <Route
              path="/property-reviews"
              element={<PublicRoute element={PropertyReviews} />}
            />
            <Route
              path="/mybooking"
              element={<UserRoute element={MyBookings} />}
            />
            <Route
              path="/reviewList"
              element={<PublicRoute element={ReviewListing} />}
            />
            <Route
              path="/property-verify"
              element={<PrivateRoute element={PropertySignUpOTP} />}
            />
            <Route 
              path="/gmaps-test" 
              element={<GmapsKeyTester />} 
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <ScrollToTop />
      </Router>
    </FilterProvider>
  );
}

export default App;
